function tuiFindTouchIndex(touches, id) {
    for (let i = 0; i < touches.length; i++) {
        const { identifier } = touches[i];
        if (identifier === id) {
            return i;
        }
    }
    return -1;
}

/**
 * Generated bundle index. Do not edit.
 */

export { tuiFindTouchIndex };
